<table class="table table-sm">
  <thead>
    <tr>
      <th colspan="2">Television</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Name</td>
      <td>{{ tvChannel()?.Name }}</td>
    </tr>
    <tr>
      <td>Description</td>
      <td>{{ tvChannel()?.Description }}</td>
    </tr>
  </tbody>
</table>